import { Tooltip } from "@material-ui/core";
import { useFlag } from "@unleash/proxy-client-react";
import axios from "axios";
import { differenceInDays, format, isValid, parseISO } from "date-fns";
import React, { useEffect, useMemo, useState } from "react";
import BlockUi from "react-block-ui";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { v4 as uuidv4 } from "uuid";
import PaymentLinkModal from "../../../../components/PaymentLinkModal";
import { generateTraceId } from "../../../../helpers";
import FloatToCurrency from "../../../../helpers/FloatToCurrency";
import { getCardsToMigrate } from "../../../../helpers/payment/migration";
import { cancelSubscription } from "../../../../helpers/subscription";
import { OfferAPI } from "../../../../api/payments/offer/api";
import CancelModal from "../CancelModal";
import ClientAccessToggle from "../ClientAccessToggle";
import CourtesyModal from "../CourtesyModal";
import PixModal from "../PixModal";
import UserAccessHistory from "../UserAccessHistory";
import { Field, InfoIcon } from "../clienteUi";
import { JdsButton } from "../../../../components/jds/JdsButton";
import { JdsTag } from "../../../../components/jds/JdsTag";
import "../../../../components/jds/jds.css";
import { config } from "../../../../../config/envs";
import {
  CourtesyBlockedError,
  useFinanceiroCourtesySubmit
} from "../financeiro.courtesy.hook";

const list_status = [
  { id: "paid", text: "Ativo" },
  { id: "active", text: "Ativo" },
  { id: "unpaid", text: "Pagamento pendente" },
  { id: "waiting_payment", text: "Aguardando pagamento" },
  { id: "canceled", text: "Cancelado" },
  { id: "trialing", text: "Período de teste" },
  { id: "pending_payment", text: "Pagamento pendente" },
  { id: "pending", text: "Pagamento pendente" },
  { id: "ended", text: "Finalizado" },
  { id: "failed", text: "Falha no pagamento" },
  { id: "refused", text: "Recusado" },
];
const payment_methods = [
  { id: "credit_card", text: "Cartão de crédito" },
  { id: "boleto", text: "Boleto" },
  { id: "pix", text: "Pix" },
];

const canceledStatus = ["canceled", "CANCELED"];

export default function FinanceiroLegacy(props) {
  const dispatch = useDispatch();
  const isFeatureFlagEnabled = useFlag("EnablePixPayments");
  const enableOrganicMigration = useFlag("enableOrganicMigrationAdmin");
  const [migrationData, setMigrationData] = useState(null);
  const [isSettlingCharge, setIsSettlingCharge] = useState(false);
  const [isLoadingManualSync, setIsLoadingManualSync] = useState(false);
  const [isLoadingPaymentLink, setIsLoadingPaymentLink] = useState(false);
  const [isCancelingModal, setIsCancelingModal] = useState(false);
  const [isPixModal, setIsPixModal] = useState(false);
  const [pixLoading, setPixLoading] = useState(false);
  const [pixData, setPixData] = useState(null);
  const [paymentLinkModal, setPaymentLinkModal] = useState({});
  const [isCourtesyModalOpen, setIsCourtesyModalOpen] = useState(false);
  const [isCourtesyLoading, setIsCourtesyLoading] = useState(false);
  const isUserAccessFlagEnabled = useFlag("USER_ACCESS_CONTROL");
  const customer = useSelector(
    state => state.subscription.customer
  );

  const user = useSelector(state => state.auth.user);
  const clientSubscription = useSelector(
    state => state.app.client_subscription
  );
  const isLoadingClientSubscription = useSelector(
    state => state.app.is_loading_client_subscription
  );
  const isDeleted = props.formik.values.deleted_at;
  const settleCharge = async () => {
    if (
      window.confirm(
        "Confirma pagamento via PIX? Ação não válida para pagamento via boleto."
      )
    ) {
      setIsSettlingCharge(true);
      try {
        const response = await axios.post(
          process.env.REACT_APP_API_URL + "/clients/settleCharge",
          { id: props.cliente_id },
          {
            headers: {
              "x-trace-id": generateTraceId()
            }
          }
        );
        if (response && response.data.success) {
          toast.success("Pagamento baixado com sucesso!");
          dispatch({
            type: "LOAD_CLIENT_SUBSCRIPTION",
            payload: {
              id: props.cliente_id,
              useV2: !!clientSubscription?.external_id,
            },
          });
        } else {
          toast.error("Ocorreu um erro ao dar baixa no pagamento.");
        }
      } catch (err) {
        toast.error("Ocorreu um erro ao dar baixa no pagamento.");
      }
      setIsSettlingCharge(false);
    }
  };

  const upgradeModal = () => {
    let title;
    let subtitle;
    if (clientSubscription.info.status === "canceled") {
      title = "Reativar plano";
      subtitle = "Basta escolher um plano para reativar agora mesmo.";
    } else {
      title = "Upgrade de plano";
      subtitle = "Basta escolher um plano para realizar o upgrade agora mesmo.";
    }
    dispatch({
      type:
        clientSubscription.info.provider === "pagarme_v5" ||
        enableOrganicMigration
          ? "SET_MODAL_SUBSCRIPTION_POLLING"
          : "SET_MODAL_SUBSCRIPTION",
      payload: {
        visible: true,
        title: title,
        subtitle: subtitle,
        client_id: props.cliente_id,
        migrationData: migrationData,
        callback: () => {
          dispatch({
            type: "LOAD_CLIENT_SUBSCRIPTION",
            payload: {
              id: props.cliente_id,
              useV2: !!clientSubscription?.external_id,
            },
          });
        },
      },
    });
  };

  const handleCancel = async (reason) => {
    try {
      await cancelSubscription(props.cliente_id, user.client_id, reason);
      toast.success("A assinatura foi cancelada com sucesso.");
      dispatch({
        type: "LOAD_CLIENT_SUBSCRIPTION",
        payload: { id: props.cliente_id, useV2: isJussubClient },
      });
      setIsCancelingModal(false);
    } catch (error) {
      toast.error(
        error?.response?.data?.message ||
          "Ocorreu um erro ao cancelar a assinatura, por favor, tente novamente mais tarde."
      );
    }
  };

  const cancelClick = () => {
    setIsCancelingModal(true);
  };

  const manualSync = async (subscription_id) => {
    if (isJussubClient) return;
    setIsLoadingManualSync(true);
    try {
      const response = await axios.post(
        config.app.adminBaseUrl +
          `/subscription/manual-sync/${subscription_id}`,
        {},
        {
          headers: {
            "x-trace-id": generateTraceId(),
          },
        },
      );
      if (![200, 201, 204].includes(response.status)) {
        throw new Error("Erro ao sincronizar assinatura.");
      }
      toast.success("A assinatura foi sincronizada com sucesso.");
      dispatch({
        type: "LOAD_CLIENT_SUBSCRIPTION",
        payload: {
          id: props.cliente_id,
          useV2: !!clientSubscription?.external_id,
        },
      });
    } catch {
      toast.error(
        "Ocorreu um erro ao sincronizar a assinatura, por favor, tente novamente mais tarde.",
      );
    } finally {
      setIsLoadingManualSync(false);
    }
  };

  const safeDateParse = (dateString, formatStr) => {
    if (!dateString) {
      return "-";
    }

    let parsed;

    if (dateString.endsWith("Z")) {
      const localDateString = dateString.replace("Z", "");
      parsed = parseISO(localDateString);
    } else {
      parsed = parseISO(dateString);
    }

    if (!isValid(parsed)) {
      return "-";
    }

    return format(parsed, formatStr);
  };

  const handlePix = async () => {
    if (!isFeatureFlagEnabled) {
      return;
    }
    if (
      !clientSubscription?.client_id ||
      !clientSubscription?.plan_details?.gateway_id
    ) {
      toast.error(
        "Dados da assinatura incompletos. Por favor, recarregue a página.",
      );
      return;
    }
    try {
      setPixLoading(true);
      const response = await axios.post(
        process.env.REACT_APP_JUSBILL_URL +
          `/charges/pix/${clientSubscription.client_id}`,
        {
          plan_id: clientSubscription.plan_details.gateway_id
        },
        {
          headers: {
            "x-trace-id": generateTraceId()
          }
        }
      );
      if (![200, 201, 204].includes(response.status)) {
        throw new Error("Erro ao gerar o pix.");
      }
      const lastTx =
        response?.data?.charges?.[0]?.last_transaction ||
        response?.data?.last_transaction;
      if (!lastTx?.expires_at) {
        throw new Error("Resposta inválida ao gerar PIX (dados ausentes).");
      }
      const timer = Math.floor(
        (new Date(lastTx.expires_at) - new Date()) / 1000
      );
      setPixData({ ...response.data, timer });
      setIsPixModal(true);
    } catch (error) {
      console.error("Erro ao gerar PIX:", error);
      toast.error(
        error.response?.data?.message ||
          "Ocorreu um erro ao gerar o pix, por favor, tente novamente mais tarde.",
      );
    } finally {
      setPixLoading(false);
    }
  };

  const handleCreateCourtesy = async data => {
    if (!props.cliente_id) {
      toast.error("Cliente não encontrado.");
      return;
    }
    setIsCourtesyLoading(true);
    try {
      const response = await createCourtesy(data);

      if (![200, 201, 204].includes(response.status)) {
        throw new Error("Erro ao criar cortesia.");
      }

      toast.success("Cortesia criada com sucesso!");
      setIsCourtesyModalOpen(false);
      dispatch({
        type: "LOAD_CLIENT_SUBSCRIPTION",
        payload: { id: props.cliente_id }
      });
    } catch (error) {
      toast.error(
        error instanceof CourtesyBlockedError
          ? error.message
          : error.response?.data?.message ||
              "Ocorreu um erro ao criar a cortesia, por favor, tente novamente."
      );
    } finally {
      setIsCourtesyLoading(false);
    }
  };

  const isPeriodEndingSoon = () => {
    const allowedStatuses = [
      "unpaid",
      "waiting_payment",
      "pending_payment",
      "pending",
      "failed",
      "canceled"
    ];
    if (allowedStatuses.includes(clientSubscription.info.status)) return true;
    if (!clientSubscription.info?.current_period_end) return false;
    const endDate = parseISO(clientSubscription.info.current_period_end);
    if (!isValid(endDate)) return false;
    return differenceInDays(endDate, new Date()) <= 2;
  };

  const handleCheckPaymentLink = async (originFlow) => {
    try {
      setIsLoadingPaymentLink(true);

      const func = isJussubClient
        ? OfferAPI.getActiveV2
        : OfferAPI.getActive;
      const data = await func(clientSubscription?.client_id);

      if (!data.success) {
        setPaymentLinkModal({ isOpen: true, originFlow });
      } else {
        setPaymentLinkModal({ isOpen: true, originFlow, data: { ...data, email: customer?.email } });
      }
    } catch (error) {
      toast.error("Ocorreu um erro ao verificar o link de pagamento.");
    } finally {
      setIsLoadingPaymentLink(false);
    }
  };

  const handleUpdatePlanOrActivateButton = async () => {
    const flow = canceledStatus.includes(clientSubscription.info.status)
      ? "reactivation_plan"
      : "upgrade_plan";
    if (flow === "reactivation_plan" && clientSubscription.external_id) {
      // call reativation route
      toast.warn("reactivation will be implemented for jussub ASP...");
      return;
    }

    const isOrganicMigrationEligible =
      enableOrganicMigration &&
      !isJussubClient &&
      clientSubscription.info.provider === "pagarme" &&
      migrationData?.currentSubscriptionId ===
        clientSubscription.info.subscription_id;

    if (isOrganicMigrationEligible) {
      upgradeModal();
    } else {
      await handleCheckPaymentLink(flow);
    }
  };

  const isJussubClient = useMemo(() => !!customer?.external_id, [
    customer?.external_id,
  ]);

  const hasCustomerLoaded = Object.keys(customer).length > 0;

  const {
    createCourtesy,
    useJusSub: useJusSubCourtesy
  } = useFinanceiroCourtesySubmit(props.cliente_id, {
    isJussubClient,
    isCustomerLoaded: customer?.id === props.cliente_id
  });

  useEffect(() => {
    if (customer?.id === props.cliente_id) return;
    dispatch({
      type: "LOAD_SUBSCRIPTION_CUSTOMER",
      payload: { id: props.cliente_id },
    });
  }, [dispatch, props.cliente_id, customer?.id]);

  useEffect(() => {
    if (!hasCustomerLoaded) return;
    dispatch({
      type: "LOAD_CLIENT_SUBSCRIPTION",
      payload: { id: props.cliente_id, useV2: isJussubClient },
    });

    if (isJussubClient) {
      dispatch({
        type: "LOAD_CLIENT_PLAN_OFFERS",
        payload: { client_id: props.cliente_id },
      });
    }

    return () => {
      dispatch({ type: "CLEAR_CLIENT_PLAN_OFFERS" });
    };
  }, [props.cliente_id, isJussubClient, hasCustomerLoaded, dispatch]);

  useEffect(() => {
    if (
      !enableOrganicMigration ||
      isJussubClient ||
      !clientSubscription?.client_id ||
      clientSubscription?.info?.provider !== "pagarme"
    ) {
      setMigrationData(null);
      return;
    }

    let isMounted = true;

    getCardsToMigrate(clientSubscription.client_id)
      .then((data) => {
        if (isMounted) {
          setMigrationData({
            ...data,
            enableOrganicMigration,
            currentProvider: clientSubscription.info?.provider,
            currentSubscriptionId: clientSubscription.info?.subscription_id,
          });
        }
      })
      .catch(() => {
        if (isMounted) setMigrationData(null);
      });

    return () => {
      isMounted = false;
    };
  }, [
    enableOrganicMigration,
    isJussubClient,
    clientSubscription?.client_id,
    clientSubscription?.info,
  ]);

  const info = clientSubscription.info;
  const hasSubscription = Object.keys(clientSubscription).length > 0;

  return (
    <BlockUi
      tag="div"
      blocking={
        isLoadingClientSubscription || isSettlingCharge || isLoadingManualSync
      }
    >
      <div className="jds-scope">
        <div className="d-flex justify-content-between align-items-start mb-12">
          <div>
            <h1 className="jds-title-lg">Situação da assinatura</h1>
            <p className="text-muted mt-2 mb-0">
              Informações sobre a assinatura do cliente.
            </p>
          </div>
          {isUserAccessFlagEnabled && (
            <ClientAccessToggle clientId={props.cliente_id} />
          )}
        </div>
        {hasSubscription && (
          <>
            <div className="jds-card mb-5">
              <h2 className="jds-title-sm">Plano contratado</h2>
              <p className="jds-title-lg mt-2">{info.plan}</p>

              <Field label="Status">
                <span>
                  {list_status.find((status) => status.id === info?.status)
                    ?.text ?? info?.status}
                </span>
                {info.status === "active" && info.payment_method === "pix" && (
                  <JdsTag color="success" label="Pago por pix" />
                )}
                {info.reason?.message && (
                  <Tooltip
                    title={info.reason.message + " - " + info.reason.details}
                    placement={"right"}
                    arrow
                  >
                    <span
                      className="d-inline-flex"
                      style={{ color: "var(--fg-neutral-subtle)" }}
                    >
                      <InfoIcon />
                    </span>
                  </Tooltip>
                )}
              </Field>
              <Field label="Valor cobrado">
                {info.charged_amount != null
                  ? `R$ ${FloatToCurrency(info.charged_amount)}`
                  : "—"}
              </Field>
              {info.subscription_provider !== "jussub" && (
                <p className="cd-help mb-0 mt-1">
                  Valor cobrado disponível apenas para assinaturas JusSub.
                </p>
              )}
              <Field label="Valor do plano">
                R$ {FloatToCurrency(info.plan_amount)}
              </Field>

              <Field label="Início do período atual">
                {safeDateParse(info.current_period_start, "dd/MM/yyyy HH:mm")}
              </Field>
              <Field label="Fim do período atual">
                {safeDateParse(info.current_period_end, "dd/MM/yyyy HH:mm")}
              </Field>
              <Field label="Última atualização">
                {safeDateParse(info.latest_update, "dd/MM/yyyy HH:mm")}
              </Field>
              <Field label="Forma de pagamento">
                {payment_methods.find(
                  (method) => method.id === info.payment_method,
                )?.text ?? info.payment_method}
              </Field>

              {info?.tickets?.length > 0 &&
                info.tickets.map((ticket) => (
                  <p key={ticket.pdf} className="mb-0 mt-2">
                    <a
                      href={ticket.pdf}
                      target="_blank"
                      rel="noreferrer"
                      style={{
                        pointerEvents: isDeleted ? "none" : "auto",
                        opacity: isDeleted ? "0.5" : "1",
                      }}
                    >
                      Acessar boleto
                    </a>
                  </p>
                ))}

              {info.payment_method === "credit_card" &&
              info?.card_brand &&
              info?.card_last_digits ? (
                <>
                  <Field label="Bandeira do cartão">
                    {info?.card_brand?.toUpperCase()}
                  </Field>
                  <Field label="Últimos dígitos do cartão">
                    {info?.card_last_digits}
                  </Field>
                </>
              ) : (
                <div className="cd-alert mt-4 mb-0">
                  Cliente sem cartão de crédito vinculado a assinatura
                </div>
              )}
            </div>
            {isUserAccessFlagEnabled && (
              <UserAccessHistory clienteId={props.cliente_id} />
            )}
          </>
        )}
        <div className="cd-actions mb-5">
          {hasSubscription && (
            <JdsButton
              variant="outlined"
              color="neutral"
              onClick={() => handleCheckPaymentLink("url_subscription")}
              disabled={isLoadingPaymentLink}
            >
              URL da assinatura
            </JdsButton>
          )}
          {hasSubscription && !isDeleted && (
            <JdsButton
              onClick={() => handleUpdatePlanOrActivateButton()}
              disabled={isLoadingPaymentLink}
            >
              {canceledStatus.includes(info.status)
                ? "Reativar plano"
                : "Upgrade de plano"}
            </JdsButton>
          )}
          {hasSubscription &&
            info.status &&
            !canceledStatus.includes(info.status) &&
            !isDeleted && (
              <JdsButton
                variant="outlined"
                color="error"
                onClick={() => cancelClick()}
              >
                Cancelar assinatura
              </JdsButton>
            )}
          {hasSubscription && !isDeleted && (
            <JdsButton
              variant="outlined"
              color="neutral"
              onClick={settleCharge}
              disabled={
                info.provider === "pagarme_v5" ||
                !!clientSubscription.external_id ||
                isDeleted
              }
            >
              Dar baixa no pagamento Pix
            </JdsButton>
          )}
          {!isDeleted && (
            <JdsButton
              variant="outlined"
              color="neutral"
              onClick={() => setIsCourtesyModalOpen(true)}
            >
              Criar cortesia
            </JdsButton>
          )}
          {clientSubscription.info?.provider === "pagarme" && !isDeleted && (
            <JdsButton
              variant="outlined"
              color="neutral"
              onClick={() => manualSync(clientSubscription.info.subscription_id)}
            >
              Sincronizar
            </JdsButton>
          )}
          {isFeatureFlagEnabled &&
            clientSubscription.info?.provider === "pagarme_v5" &&
            (clientSubscription.info?.payment_method === "boleto" ||
              clientSubscription.info?.payment_method === "pix") &&
            isPeriodEndingSoon() && (
              <JdsButton
                variant="outlined"
                color="neutral"
                onClick={() => handlePix()}
                disabled={pixLoading}
              >
                {pixLoading ? (
                  <span
                    className="spinner-border spinner-border-sm"
                    role="status"
                    aria-hidden="true"
                  ></span>
                ) : (
                  "Pagar com o Pix"
                )}
              </JdsButton>
            )}
        </div>
      </div>
      {isCancelingModal && (
        <CancelModal setOpen={setIsCancelingModal} onConfirm={handleCancel} />
      )}
      {isPixModal &&
        (pixData?.charges?.[0]?.last_transaction ||
          pixData?.last_transaction) && (
          <PixModal
            setOpen={setIsPixModal}
            pixCode={
              pixData.charges?.[0]?.last_transaction?.qr_code ||
              pixData?.last_transaction?.qr_code
            }
            pixQR={
              pixData.charges?.[0]?.last_transaction?.qr_code_url ||
              pixData?.last_transaction?.qr_code_url
            }
            pixTimer={pixData.timer}
            clientId={clientSubscription.client_id}
          />
        )}

      {paymentLinkModal.isOpen && (
        <PaymentLinkModal
          isOpen={paymentLinkModal.isOpen}
          onClose={() =>
            setPaymentLinkModal({ ...paymentLinkModal, isOpen: false })
          }
          originFlow={paymentLinkModal.originFlow}
          paymentLink={paymentLinkModal.data}
          isJussub={isJussubClient}
        />
      )}
      <CourtesyModal
        isOpen={isCourtesyModalOpen}
        onClose={() => setIsCourtesyModalOpen(false)}
        onConfirm={handleCreateCourtesy}
        isLoading={isCourtesyLoading}
        clientEmail={props.formik.values.email}
        currentPlanName={clientSubscription?.plan_details?.name || clientSubscription?.info?.plan}
        useJusSub={useJusSubCourtesy}
      />
    </BlockUi>
  );
}
